// modules/core/components/InfoTooltip/index.tsx
import * as React from 'react'

import { Box, Icon, Tooltip } from '@factorialco/deprecated-design-system'

interface Props {
  label: string
}

const InfoTooltip = ({ label }: Props) => {
  const [open, setOpen] = React.useState(false)

  return (
    <Box
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
      tabIndex={0}
    >
      <Tooltip.Alt
        label={label}
        open={open}
        attachment="middle left"
        targetAttachment="middle right"
        inline
      >
        <Icon.Medium icon="info-circle" color="grey800" />
      </Tooltip.Alt>
    </Box>
  )
}

export default InfoTooltip
